import React from "react"
import CustomAccountingForm from "./Form"

export default function CreateCustomLoanAccounting() {
  return <CustomAccountingForm isUpdate={ true } />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/CustomAccountingRules/Create.js